import * as JsonResponse1 from "./JsonResponse1";
import * as t from "io-ts";

export const codec = JsonResponse1.createCodec(
    t.array(t.type({})),
    t.type({}),
);

export type T = t.TypeOf<typeof codec>;

export const newDefault = (): T => ({
    data: [],
    meta: {},
});
